import styled from 'styled-components';

export const InfoSectionWrapper = styled.div`
  padding: 15px 7px;
`;

export const CredentialsWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
`;

export const ConnectionCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;
